import { Flex } from "@chakra-ui/react";
import { WriteLeftDotLine } from "../../ComponentLayouter/WriteLeftDotLine";
import { AddMarginLeft } from "../../ComponentLayouter/AddMarginLeft";

export const SpotStatDummy = ({
  hasLeftMargin,
}: {
  hasLeftMargin: boolean;
}) => {
  const Wrapper = hasLeftMargin ? AddMarginLeft : WriteLeftDotLine;
  return (
    <Wrapper>
      <Flex
        alignItems="baseline"
        borderBottom={""}
        data-testid={"spot-stat-dummy"}
      >
        －
      </Flex>
    </Wrapper>
  );
};
